import engagementGroupIcon from "../../assets/icon/Engagement.svg";
import vendorProvidersGroupIcon from "../../assets/icon/Vendor &  Providers.svg";
import organizationAccountsGroupIcon from "../../assets/icon/Organization & Accounts.svg";
import messageOperationsGroupIcon from "../../assets/icon/Message Operations.svg";
import analyticsReportsGroupIcon from "../../assets/icon/Analytics & Reports.svg";
import complianceSecurityGroupIcon from "../../assets/icon/Compliance & Security.svg";
import billingPricingGroupIcon from "../../assets/icon/Billing & Pricing.svg";
import developerToolsGroupIcon from "../../assets/icon/Developer Tools.svg";
import markingIcon from "../../assets/icon/Marking.svg";
import utilityIcon from "../../assets/icon/Utility.svg";
import updateFileIcon from "../../assets/icon/Update file.svg";
import hlrScheduleIcon from "../../assets/icon/HLRSchedule.svg";
import accessTokenIcon from "../../assets/icon/Access Token.svg";
import configureIcon from "../../assets/icon/Configure.svg";
import deleteUserIcon from "../../assets/icon/Delete User.svg";
import multiAccessIcon from "../../assets/icon/multi access.svg";
import sessionIcon from "../../assets/icon/Session.svg";
import transactionModeIcon from "../../assets/icon/transaction mode.svg";
import webAccessLogIcon from "../../assets/icon/web access log.svg";
import abortedIcon from "../../assets/icon/Aborted.svg";
import balanceIcon from "../../assets/icon/balance.svg";
import advancedSettingsIcon from "../../assets/icon/Advanced Settings.svg";
import aggregatorIcon from "../../assets/icon/Aggregator.svg";
import alertsIcon from "../../assets/icon/Alerts.svg";
import batchIcon from "../../assets/icon/Batch.svg";
import blockedIcon from "../../assets/icon/Blocked.svg";
import bulkManagementIcon from "../../assets/icon/Bulk Management.svg";
import bulkMessageIcon from "../../assets/icon/Bulk Message.svg";
import campaignManagerIcon from "../../assets/icon/Campaign Mananger.svg";
import campaignReportIcon from "../../assets/icon/Campaign report.svg";
import consumptionIcon from "../../assets/icon/Consumption.svg";
import contactsIcon from "../../assets/icon/Contacts.svg";
import coverageIcon from "../../assets/icon/Coverage.svg";
import crdEurIcon from "../../assets/icon/CRD EUR.svg";
import darkLightModeIcon from "../../assets/icon/Dark light mode.svg";
import dashboardIcon from "../../assets/icon/Dashboard.svg";
import defaultViewIcon from "../../assets/icon/default view.svg";
import deliveryAdvanceIcon from "../../assets/icon/Delivery Advance.svg";
import deliveryContentIcon from "../../assets/icon/Delivery Content.svg";
import deliveryLatencyIcon from "../../assets/icon/Delivery Latency.svg";
import deliveryIcon from "../../assets/icon/Delivery.svg";
import detailedAnalyticsIcon from "../../assets/icon/Detailed Analytics.svg";
import dltComplianceIcon from "../../assets/icon/DLT Compliance.svg";
import documentationIcon from "../../assets/icon/Documentation.svg";
import edrIcon from "../../assets/icon/EDR.svg";
import encodingToolsIcon from "../../assets/icon/Encoding Tools.svg";
import errorCodesIcon from "../../assets/icon/Error Codes.svg";
import sdkIcon from "../../assets/icon/SDK.svg";
import downloadIcon from "../../assets/icon/Download.svg";
import fileDownloadProgressIcon from "../../assets/icon/file download progress.svg";
import filterIcon from "../../assets/icon/Filter.svg";
import flagIcon from "../../assets/icon/flag.svg";
import firewallIcon from "../../assets/icon/Firewall.svg";
import groupConnectionsIcon from "../../assets/icon/Group Connections.svg";
import gridViewIcon from "../../assets/icon/Grid view.svg";
import hlrConnectionIcon from "../../assets/icon/HLR Connection.svg";
import httpConnectionsIcon from "../../assets/icon/HTTP Connections.svg";
import lookUpIcon from "../../assets/icon/Look-up.svg";
import loopingIcon from "../../assets/icon/Looping.svg";
import logoutIcon from "../../assets/icon/Logout.svg";
import listViewIcon from "../../assets/icon/List View.svg";
import messagesIcon from "../../assets/icon/Messages.svg";
import networksIcon from "../../assets/icon/Networks.svg";
import notificationIcon from "../../assets/icon/Notification.svg";
import optInPagesIcon from "../../assets/icon/Opt-in Pages.svg";
import organizationsIcon from "../../assets/icon/Organizations.svg";
import pcapIcon from "../../assets/icon/Packet Capture (PCAP).svg";
import performanceIcon from "../../assets/icon/Performance.svg";
import profitIcon from "../../assets/icon/Profit.svg";
import providersIcon from "../../assets/icon/Providers.svg";
import quickMessageIcon from "../../assets/icon/Quick Message.svg";
import resellersIcon from "../../assets/icon/Resellers.svg";
import routeIcon from "../../assets/icon/Route.svg";
import routingIcon from "../../assets/icon/Routing.svg";
import saveIcon from "../../assets/icon/Save.svg";
import scheduleIcon from "../../assets/icon/Schedule.svg";
import scheduleAltIcon from "../../assets/icon/Schedule-1.svg";
import senderIdManagementIcon from "../../assets/icon/Sender ID Management.svg";
import senderBasedRoutingIcon from "../../assets/icon/Sender-Based Routing.svg";
import smscConnectionsIcon from "../../assets/icon/SMSC Connections.svg";
import submissionReportIcon from "../../assets/icon/Submission Report.svg";
import summaryIcon from "../../assets/icon/Summary.svg";
import templatesIcon from "../../assets/icon/Templates.svg";
import tpsIcon from "../../assets/icon/TPS.svg";
import transactionHistoryIcon from "../../assets/icon/Transaction History.svg";
import trafficBlockingIcon from "../../assets/icon/Traffic Blocking.svg";
import trafficLimitsIcon from "../../assets/icon/Traffic Limits.svg";
import twoWayMessagingIcon from "../../assets/icon/Two-Way Messaging.svg";
import userIcon from "../../assets/icon/User.svg";
import usersIcon from "../../assets/icon/Users.svg";
import vendorSummaryIcon from "../../assets/icon/Vendor Summary.svg";
import vendorsIcon from "../../assets/icon/Vendors.svg";

/** Central map of redesign icons from `src/assets/icon`. */
export const APP_ICONS = {
  // Group Sidebar Icons
  engagement: engagementGroupIcon,
  customerEngagement: engagementGroupIcon,
  customer_engagement: engagementGroupIcon,
  vendorsProviders: vendorProvidersGroupIcon,
  vendorProviders: vendorProvidersGroupIcon,
  vendors_providers: vendorProvidersGroupIcon,
  organizationAccounts: organizationAccountsGroupIcon,
  organization_accounts: organizationAccountsGroupIcon,
  messageOperations: messageOperationsGroupIcon,
  message_operations: messageOperationsGroupIcon,
  analyticsReports: analyticsReportsGroupIcon,
  analytics_reports: analyticsReportsGroupIcon,
  complianceSecurity: complianceSecurityGroupIcon,
  compliance_security: complianceSecurityGroupIcon,
  billingPricing: billingPricingGroupIcon,
  billingRouting: billingPricingGroupIcon,
  billing_pricing: billingPricingGroupIcon,
  billing_routing: billingPricingGroupIcon,
  developerTools: developerToolsGroupIcon,
  developers: developerToolsGroupIcon,
  developer_tools: developerToolsGroupIcon,
  marking: markingIcon,
  marketing: markingIcon,
  utility: utilityIcon,
  updateFile: updateFileIcon,
  update_file: updateFileIcon,
  hlrSchedule: hlrScheduleIcon,
  hlr_schedule: hlrScheduleIcon,
  accessToken: accessTokenIcon,
  access_token: accessTokenIcon,
  authentication: accessTokenIcon,
  configure: configureIcon,
  configuration: configureIcon,
  delete: deleteUserIcon,
  deleteUser: deleteUserIcon,
  delete_user: deleteUserIcon,
  multiAccess: multiAccessIcon,
  multi_access: multiAccessIcon,
  session: sessionIcon,
  balance: balanceIcon,
  transactionMode: transactionModeIcon,
  transaction_mode: transactionModeIcon,
  webAccessLog: webAccessLogIcon,
  web_access_log: webAccessLogIcon,
  aborted: abortedIcon,
  advancedSettings: advancedSettingsIcon,
  aggregator: aggregatorIcon,
  alerts: alertsIcon,
  alert: alertsIcon,
  batch: batchIcon,
  blocked: blockedIcon,
  bulkManagement: bulkManagementIcon,
  bulkMessage: bulkMessageIcon,
  bulkMail: bulkMessageIcon,
  campaignManager: campaignManagerIcon,
  campaignReport: campaignReportIcon,
  consumption: consumptionIcon,
  contacts: contactsIcon,
  coverage: coverageIcon,
  crdEur: crdEurIcon,
  wallet: crdEurIcon,
  darkLightMode: darkLightModeIcon,
  darkMode: darkLightModeIcon,
  theme: darkLightModeIcon,
  dashboard: dashboardIcon,
  defaultView: defaultViewIcon,
  default: defaultViewIcon,
  deliveryAdvance: deliveryAdvanceIcon,
  deliveryContent: deliveryContentIcon,
  deliveryLatency: deliveryLatencyIcon,
  delivery: deliveryIcon,
  detailedAnalytics: detailedAnalyticsIcon,
  dltCompliance: dltComplianceIcon,
  documentation: documentationIcon,
  edr: edrIcon,
  encodingTools: encodingToolsIcon,
  errorCodes: errorCodesIcon,
  sdk: sdkIcon,
  sdks: sdkIcon,
  fileDownloadProgress: fileDownloadProgressIcon,
  download: downloadIcon,
  downloadIcon: downloadIcon,
  filter: filterIcon,
  flag: flagIcon,
  companyFlag: flagIcon,
  firewall: firewallIcon,
  groupConnections: groupConnectionsIcon,
  gridView: gridViewIcon,
  grid: gridViewIcon,
  hlrConnection: hlrConnectionIcon,
  httpConnections: httpConnectionsIcon,
  lookUp: lookUpIcon,
  looping: loopingIcon,
  logout: logoutIcon,
  listView: listViewIcon,
  list: listViewIcon,
  messages: messagesIcon,
  networks: networksIcon,
  network: networksIcon,
  notification: notificationIcon,
  optInPages: optInPagesIcon,
  optIn: optInPagesIcon,
  subscription: optInPagesIcon,
  organizations: organizationsIcon,
  organization: organizationsIcon,
  company: organizationsIcon,
  pcap: pcapIcon,
  performance: performanceIcon,
  profit: profitIcon,
  providers: providersIcon,
  quickMessage: quickMessageIcon,
  resellers: resellersIcon,
  route: routeIcon,
  routing: routingIcon,
  save: saveIcon,
  saveFilter: saveIcon,
  schedule: scheduleIcon,
  scheduleAlt: scheduleAltIcon,
  senderIdManagement: senderIdManagementIcon,
  senderBasedRouting: senderBasedRoutingIcon,
  smscConnections: smscConnectionsIcon,
  smsc: smscConnectionsIcon,
  hlr: hlrConnectionIcon,
  http: httpConnectionsIcon,
  specialSetting: advancedSettingsIcon,
  specialSettings: advancedSettingsIcon,
  blocking: trafficBlockingIcon,
  limits: trafficLimitsIcon,
  limit: trafficLimitsIcon,
  errorCode: errorCodesIcon,
  group: groupConnectionsIcon,
  submissionReport: submissionReportIcon,
  submission: submissionReportIcon,
  summary: summaryIcon,
  templates: templatesIcon,
  tps: tpsIcon,
  trafficBlocking: trafficBlockingIcon,
  trafficLimits: trafficLimitsIcon,
  transactionHistory: transactionHistoryIcon,
  transactions: transactionHistoryIcon,
  twoWayMessaging: twoWayMessagingIcon,
  user: userIcon,
  users: usersIcon,
  vendorSummary: vendorSummaryIcon,
  vendors: vendorsIcon,
  vendor: vendorsIcon,
};

export function getAppIcon(name) {
  return APP_ICONS[name] || null;
}

/**
 * Reusable app icon from `src/assets/icon`.
 * @param {object} props
 * @param {keyof typeof APP_ICONS} [props.name] - Icon key from APP_ICONS
 * @param {string} [props.src] - Optional direct image URL (overrides name)
 * @param {number|string} [props.size] - Width/height in px
 * @param {string} [props.className]
 * @param {string} [props.alt]
 */
function AppIcon({
  name,
  src,
  size = 22,
  className = "",
  alt = "",
  style,
  ...rest
}) {
  const iconSrc = src || getAppIcon(name);
  if (!iconSrc) return null;

  const dim = typeof size === "number" ? `${size}px` : size;

  return (
    <img
      src={iconSrc}
      alt={alt}
      className={className}
      loading="lazy"
      style={{
        width: dim,
        height: dim,
        objectFit: "contain",
        flexShrink: 0,
        ...style,
      }}
      {...rest}
    />
  );
}

export default AppIcon;
